import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { setIsPhotoTourScreen } from "slices";
import { HeaderBarComp } from "components";
import { getIsMaximized } from "slices/window-slice/index";

import TopBar from "./TopBar";
import FocusedPhotoShow from "./FocusedPhotoShow";
import MobilePhotoShow from "./MobilePhotoShow";
import PhotosRow from "./PhotosRow";

const PhotosView = () => {
  const dispatch = useDispatch();
  const isMaximized = useSelector(getIsMaximized);

  const closePhotoTourScreen = () => {
    dispatch(setIsPhotoTourScreen(false));
  };

  return (
    <HeaderBarComp title={"Photos"} onBackButtonClick={closePhotoTourScreen}>
      <TopBar />
      <div className={`${isMaximized ? "hayley-px-2" : ""}`}>
        <FocusedPhotoShow />
      </div>

      <MobilePhotoShow />
      <PhotosRow />
    </HeaderBarComp>
  );
};

export default PhotosView;
